import { AnyAction, PayloadAction, createAction } from '@reduxjs/toolkit';

import type { AnyApi } from '../../buildCreateApi';

/**
 * Формат мета-информации в экшенах {reducerPath}/executeMutation/rejected.
 * Экшен создается внутри RTK Query, но не экспортируется.
 */
export type MutationRejectedAction = PayloadAction<
    unknown,
    string,
    {
        arg: {
            endpointName: string;
            originalArgs: unknown;
        };
        baseQueryMeta: unknown;
    },
    unknown
>;

/**
 * Создает функцию-матчер, которая определяет является ли экшен реджектом мутации.
 * @param api Инстанс RTK Query API.
 * @returns Функция-матчер, которая определяет является ли экшен реджектом мутации.
 */
export function createMutationRejectedActionMatcher<Api extends AnyApi>(api: Api) {
    const mutationRejectedAction = createAction(`${api.reducerPath}/executeMutation/rejected`);

    return function match(action: AnyAction): action is MutationRejectedAction {
        return mutationRejectedAction.match(action);
    };
}
